import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";
import ConfirmationModal from "../Modals/ConfirmationModal";
import { useLocation, useNavigate } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "./invoice.css";
import { servicePost } from "../../helper/api";
import moment from "moment";

const InvoiceDetail = () => {
  const [invoiceData, setInvoiceData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();

  console.log("invoiceData", invoiceData);

  const location = useLocation();
  const invoiceId = location?.state?.invoiceId;

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const getInvioceData = async () => {
    try {
      const gatInvoiceRes = await servicePost(
        "adminbooking/getInvoiceData",
        {
          invoiceId: invoiceId,
        },
        notification,
        authToken
      );
      console.log("gatInvoiceRes", gatInvoiceRes);
      setInvoiceData(gatInvoiceRes.data[0]);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getInvioceData();
  }, [invoiceId]);

  //
  const goToTxDetail = () => {
    navigate("/transation-detail", {
      state: { bookingId: invoiceData.bookingId },
    });
  };

  // Go To User Account
  const goToAccDetail = () => {
    navigate("/account-detail", {
      state: { AccountId: invoiceData.accountId },
    });
  };

  // Go To Contractor Account
  const goToContractorAccDetail = () => {
    navigate("/contractoraccount-detail", {
      state: { AccountId: invoiceData.contractorid },
    });
  };

  const goToBack = () => {
    navigate("/invoice");
  };

  return (
    <>
      <ConfirmationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="Are you sure to change the status of this transaction"
      />
      <Navbar />
      <Sidebar />
      <div className="trasfer-histroy-wrapper transfer-admin-history-wrap">
        <div className="container">
          <div className="invoice-detail-main-wrap">
            <div className="invoice-payment-detail-left">
              <div className="cleaner-payment-detail-left">
                <div className="cleaner-payment-tx-wrap">
                  <img
                    onClick={goToBack}
                    src="./images/icons/back-arrow.png"
                    alt="icon"
                  />
                  <h3>
                    Invoice : <span> #{invoiceData?.invoiceId} </span>
                  </h3>
                </div>
                <p>
                  Transaction ID :
                  <span className="active-tx-id" onClick={() => goToTxDetail()}>
                    #{invoiceData?.bookingId}
                  </span>
                </p>
                <p>
                  Payout ID <span> : {invoiceData?.contractorPayoutId}</span>
                </p>
              </div>

              <div className="invoice-booking-detail-wrap">
                <div className="invoice-booking-client">
                  <h3> Booking Details</h3>

                  <div className="booking-client-detail-wrap">
                    <div className="booking-client-detail">
                      <p>
                        Client:{" "}
                        <span
                          className="active-tx-id"
                          onClick={() => goToAccDetail()}
                        >
                          {invoiceData?.clientName}
                        </span>
                      </p>
                      {/* <div className="send-mail-btn">
                        <p> Send Mail</p>
                        <img src="./images/icons/sent-mail.svg" alt="icon" />
                      </div> */}
                    </div>

                    <div className="booking-client-detail">
                      <div className="booking-client-icon-wrap">
                        <p>
                          Cleaner:{" "}
                          <span
                            className="active-tx-id"
                            onClick={() => goToContractorAccDetail()}
                          >
                            {invoiceData?.contractorName}
                          </span>
                        </p>
                        {/* <img src="./images/icons/edit-icon.png" alt="icon" /> */}
                      </div>

                      {/* <div className="send-mail-btn">
                        <p> Send Mail</p>
                        <img src="./images/icons/sent-mail.svg" alt="icon" />
                      </div> */}
                    </div>
                  </div>

                  <div className="invoice-booking-industry-wrap">
                    <h4>
                      {" "}
                      {invoiceData?.industry}
                      {invoiceData?.floors && ","} {invoiceData?.floors}{" "}
                      {invoiceData?.bedrooms && ","} {invoiceData?.bedrooms}{" "}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            <div className="cleaner-payment-detail-right">
              <div className="invoice-status-wrapper">
                <h4> Status </h4>
                <div className="invoce-status-btn-wrap">
                  <p> {invoiceData?.invoiceStatus} </p>
                </div>
              </div>
              {/* <Dropdown
                onTypeChange={handleDropdownChange}
                label="Status"
                data={StatusDropdown}
              /> */}
            </div>
          </div>

          <div className="invoice-booking-detail-bottom-wrapper">
            <div className="invoice-booking-detail-bottom-left">
              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Address</p>
                </div>
                <div className="invoice-address-right">
                  <p> {invoiceData?.address} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> City:</p>
                </div>
                <div className="invoice-address-right">
                  <p> {invoiceData?.city}</p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Postal code: </p>
                </div>
                <div className="invoice-address-right">
                  <p> {invoiceData?.postalCode}</p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Schedule: </p>
                </div>
                <div className="invoice-address-right">
                  <img src="./images/icons/date.svg" alt="icon" />
                  <p className="right-border-line">
                    {moment(invoiceData.scheduleDate).format("DD MMM, YYYY")}
                  </p>
                  <img src="./images/icons/time.svg" alt="icon" />
                  <p>{invoiceData?.scheduleTime}</p>
                </div>
              </div>
            </div>

            <div className="invoice-booking-detail-bottom-right">
              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Payment Method:</p>
                </div>
                <div className="invoice-address-right">
                  <img src="./images/icons/card.svg" alt="icon" />
                  <p> {invoiceData?.paymentMethod} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Payment #ID </p>
                </div>
                <div className="invoice-address-right">
                  <p>
                    {invoiceData?.userPaymentId
                      ? invoiceData?.userPaymentId
                      : "--"}{" "}
                  </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <h4> Total </h4>
                </div>
                <div className="invoice-address-right">
                  <h4> ${invoiceData?.total}</h4>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Sub total </p>
                </div>
                <div className="invoice-address-right">
                  <p> ${invoiceData?.subTotal}</p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> YFOS Service </p>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        YFOS service fees include company charges to ensure
                        quality service and operational excellence.
                      </Tooltip>
                    }
                  >
                    <img src="./images/icons/info.svg" alt="icon" />
                  </OverlayTrigger>
                </div>
                <div className="invoice-address-right">
                  <p className="discount-text">
                    {" "}
                    -${Number(invoiceData?.yfosServiceCharge)?.toFixed(2)}
                  </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Taxes and Fee </p>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                      <Tooltip id={`tooltip-top`}>
                        Additional fees may apply for shipping, handling, and
                        taxes.
                      </Tooltip>
                    }
                  >
                    <img src="./images/icons/info.svg" alt="icon" />
                  </OverlayTrigger>
                </div>
                <div className="invoice-address-right">
                  <p>${Number(invoiceData?.fees)?.toFixed(2)} </p>
                </div>
              </div>

              <div className="invoice-address-reapet">
                <div className="invoice-address-left">
                  <p> Discount </p>
                </div>
                <div className="invoice-address-right">
                  <p className="discount-text">${invoiceData.discount} </p>
                </div>
              </div>

              <div className="invoice-payout-wrapper">
                <div className="invoice-payout-wrap">
                  <h3> Cleaner Commission </h3>
                  <p>
                    $
                    {Number(invoiceData?.cleanerCommision)
                      ? Number(invoiceData.cleanerCommision).toFixed(2)
                      : "0.00"}
                  </p>
                </div>
              </div>

              <div className="invoice-payout-wrapper">
                <div className="invoice-payout-wrap">
                  <h3> YfOS Profit </h3>
                  <p>
                    $
                    {Number(invoiceData?.yfosProfit)
                      ? Number(invoiceData?.yfosProfit).toFixed(2)
                      : "0.00"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceDetail;
